export const COLORS = {
    'yellow-300': '#fff0d7',
    'neutral-200': 'var(--color-neutral-200, #efedf2)',
    'neutral-500': 'var(--border-border-secondary, #dddae3)',
    'pink-300': '#feedea',
    'base-color': '#FFF',
    'loading-bg':
        'linear-gradient(90deg, rgba(255, 255, 255, 0.18) 31.05%, rgba(0, 0, 0, 0.00) 65.45%, rgba(255, 255, 255, 0.11) 65.45%), #EEEDF2',
};
